import { Form, Input } from "decorator-form";
import InputType from "common/form/InputType";

@Form({ title: "Completion Filter Config" })
export default class CompletionFilterConfig {
    @Input({ type: InputType.NUMBER, title: "Number of Years" })
    public lastYears?: number;
}



// WEBPACK FOOTER //
// ./src/panels/subscriptions/CompletionFilterConfig.tsx